import { Link } from "wouter";
import { PageMeta } from "@/components/PageMeta";

export default function NotFound() {
  return (
    <>
      <PageMeta title="Not found — Taidotech" description="The page you were looking for could not be found." />
      <section className="hero" style={{ minHeight: "60vh", display: "flex", alignItems: "center" }}>
        <div className="container" style={{ textAlign: "center" }}>
          <div className="eyebrow">404</div>
          <h1>We couldn't find that page.</h1>
          <p className="hero-sub" style={{ margin: "1.5rem auto 2.5rem", maxWidth: "520px" }}>
            The page you were looking for doesn't exist or has moved. Try the homepage or get in touch.
          </p>
          <div style={{ display: "flex", gap: "1rem", justifyContent: "center", flexWrap: "wrap" }}>
            <Link href="/" className="btn btn-primary">Back to home</Link>
            <Link href="/contact/" className="btn btn-outline-white">Contact us</Link>
          </div>
        </div>
      </section>
    </>
  );
}
